import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';
import '../i18n';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import heroVideo from '../assets/videos/video-2.mp4';

export default function HeroSection() {
  const { t } = useTranslation();

  // Skip the background video entirely for mobile (saves bandwidth on
  // cellular connections) and for users who've asked for reduced motion —
  // rather than mounting it and pausing after the fact.
  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const showVideo = !isMobile && !prefersReducedMotion;

  return (
    <div className='hero-container'>
      {/* Decorative background video — muted/looped, no meaningful audio,
          so no captions are needed. Not rendered at all on mobile or for
          reduced-motion users (see showVideo above). */}
      {showVideo && (
        <video
          className='hero-video'
          src={heroVideo}
          autoPlay
          muted
          loop
          playsInline
          preload='none'
          aria-hidden='true'
        />
      )}
      <div className='hero-content'>
        <h1>{t('IT_CATALIZES_YOUR_BUSINESS.text')}</h1>
        <p align='center'>{t('Creating_software_for_a_purpose.text')}</p>
        
        
        <div className='hero-btns'>
                      <Button buttonStyle='btn--primary' buttonSize='btn--large'>
                        Get Started
                      </Button>
                      <Button buttonStyle='btn--outline' buttonSize='btn--large'>
                        Learn More
                      </Button>
        </div>
      </div>
      <div className='scroll-indicator' aria-hidden='true'>
        <div className='scroll-icon' />
      </div>
    </div>
  );
}
